import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  IconButton,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import QuizIcon from "@mui/icons-material/Quiz";

export default function AppHeader({ user }) {
  const theme = useTheme();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
    background: "rgba(11,16,32,0.75)",
    backdropFilter: "blur(14px)",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
  }}
    >
      <Toolbar sx={{ minHeight: 72 }}>
        {/* Logo + Brand */}
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "12px",
              background: theme.custom.gradients.bluePurple,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
            }}
          >
            <QuizIcon />
          </Box>

          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              background: theme.custom.colors.grey,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              letterSpacing: 0.5,
            }}
          >
            Academia
          </Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        {/* User zone
        {user && (
          <IconButton>
            <Avatar
              alt={user.name}
              src={user.picture}
              sx={{
                width: 36,
                height: 36,
                border: "2px solid #36d1dc",
              }}
            />
          </IconButton>
        )} */}
      </Toolbar>
    </AppBar>
  );
}
